module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA6klEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzsSAIAKoGqoBrALKBevBp+P///9+/f4EkUMN/GABKG8Wsqttw3WPCKevu0/rJGxAagOqgSE4OzgZK2xbsWH7o2vNnL5cduWNRugehAeJohJNWrOjt3wuU1k7Y4N61NGPCpNDeaYYZG5FsmD7dr3AHXEN1136Ip/1Ldk1euWDF1MieZVPjWw4jNABZWJG046yZy1Ysm9Eya2a/hs8CwhoiEqfNmD5n1/zpqxYsSIquI6whL29Sa/3U5XMWV+fU5ccXo2kgjMjSMCgBAADWzv6pwaOVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/FK.png
// module id = 1138
// module chunks = 0